/* eslint-disable */
const de = {
  required: 'Sie müssen dieses Feld ausfüllen.',
  min: 'Sie müssen mindestens {{min}} Eintrag/Einträge vornehmen.',
  minCreateOne: 'Sie müssen mindestens einen Eintrag anlegen.',
  minChars: 'Sie müssen mindestens {{min}} Zeichen eingeben.',
  max: 'Sie dürfen maximal {{max}} Zeichen eintragen.',
  email: 'Sie müssen eine gültige E-Mail-Adresse eintragen.',
  homepage: 'Sie müssen eine gültige URL eintragen (startet mit http(s)://).',
  passwordMatch: 'Die Passwörter müssen übereinstimmen.',
  emailTaken: 'Ein Benutzer mit dieser E-Mail-Adresse ist bereits im System registriert.',
  taxIdOrTaxNumber: 'Ust-IdNr. oder Steuernummer ist Pflicht.',
  taxNumberFormat: 'Steuernummer hat die Form FF(F)/BBB(B)/UUU(U)P.',
  taxIdEuCountry: 'Ust-IdNr. ist für EU-Länder Pflicht.',
  taxId: 'Sie müssen eine gültige Ust-IdNr. eingeben.',
  taxIdForeign: 'Nur für ausländische Firmen',
  formHasErrors:
    'Das Formular wurde noch nicht vollständig oder fehlerhaft ausgefüllt. Bitte überprüfen Sie Ihre Eingaben.',
  taxIdFormat: 'Die Ust-IdNr. enthält unzulässige Sonder-/Leerzeichen oder ist zu kurz.',
  summerOrWinter: 'Winter oder Sommer muss aktiv sein.',
  minOne: 'Mindestens ein Element muss ausgewählt werden.',
  endDateBeforeStartDate: 'Das Enddatum darf nicht vor dem Startdatum gesetzt werden.',
  dischargeByStudentsUntilBeforeEndDate:
    'Die Austragung durch Studenten darf nicht vor dem Enddatum enden.',
  minDate: 'Das Datum muss nach dem {{date}} liegen.',
  productImage: 'Sie müssen ein Produktbild hochladen.',
  number: 'Das Format der Telefonnummer ist nicht erlaubt',
  oneWeekDayRequired: 'Mindestens ein Wochenende muss ausgewählt sein'
};

export default de;
export type ValidationTranslation = typeof de;
